import React, { useState } from 'react';
import AddExistingStudent from './AddExistingStudent';
import AddNewStudent from './AddNewStudent';
import { useSelector } from 'react-redux';
import { textIdentifier } from '../../textIdentifier';

const AddStudentModal = ({ setShowAddStudentModal }) => {
	const [existingStudent, setExistingStudent] = useState(false);
	const {lang} = useSelector(state => state.main)

	return (
		<div
			className="modal fade show"
			id="addStudentModal"
			tabindex="-1"
			aria-labelledby="Add Class Modal"
			aria-hidden="true"
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-body">
						<span className="modal-title">{textIdentifier["add-student"][lang]}</span>

						<ul className="nav justify-content-center tab">
							<li className="nav-item">
								<button
									type="button"
									className={`tablinks btn-outlined ${
										existingStudent ? "" : "active"
									}`}
									aria-current="page"
									onClick={() => setExistingStudent(false)}
								>
									{textIdentifier["new-student"][lang]}
								</button>
							</li>
							<li className="nav-item">
								<button
									type="button"
									className={`tablinks btn-outlined ${
										!existingStudent ? "" : "active"
									}`}
									onClick={() => setExistingStudent(true)}
								>
									{textIdentifier["existing-student"][lang]}
								</button>
							</li>
						</ul>

						{!existingStudent ? (
							<AddNewStudent setShowAddStudentModal={setShowAddStudentModal} />
						) : (
							<AddExistingStudent
								setShowAddStudentModal={setShowAddStudentModal}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddStudentModal;